export default () =>{
    const footerBlockLists = document.querySelectorAll(".f-preview");

    footerBlockLists.forEach(el => {
        let elInner = el.querySelectorAll(".list-line__item");
        elInner.forEach(itemInner => {
            itemInner.addEventListener('mouseenter', () => {
                const footerItemImg = el.querySelector(".f-preview__bg-img");
                let data = itemInner.dataset.footerImg;
                footerItemImg.src=data;
            })
        });

        let elBlockInner = el.querySelector(".list-line");
        elBlockInner.addEventListener('mouseleave', () => {
            const footerItemImg = el.querySelector(".f-preview__bg-img");
            let data = elBlockInner.dataset.footerImgDefault;
            footerItemImg.src=data;
        })

    });

};
